<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t(`admin.interfaces.pagePaymentRequest.title.${subConfig}`) }}
    </portal>
    <template v-if="config !== null">
      <card :title="$t('admin.interfaces.pagePaymentRequest.card.general')" cols="12 6@desktop" rows="2">
        <card-badge :tooltip="$t('betaVersion.tooltip')">{{ $t('betaVersion.title') }}</card-badge>
        <hm-card-inner full-size>
          <span class="warning-text warning-text--full-size warning-text--no-margin col-12">Diese Funktion steht <b>während der β-Testphase <u>kostenfrei</u></b> zur Verfügung. <br/>Nach Abschluss der β-Testphase wird für Zahlungen über Stripe Terminal voraussichtlich eine <b>Gebühr von 0,1 % des Zahlungsbetrags</b> erhoben - die regulären Stripe-Gebühren bleiben davon unberührt.</span>
        </hm-card-inner>
        <hm-card-inner v-if="subConfig === 'terminalConfiguration'">
          <hm-input-toggle v-model="config.enabled" :label="$t('admin.interfaces.pagePaymentRequest.enabled')" name="enabled" />
          <hm-input-select v-model="config.defaultTerminalIhsId" :label="$t('admin.interfaces.pagePaymentRequest.defaultTerminalIhsId')" name="defaultTerminalIhsId">
            <option :value="null"></option>
            <option v-for="item in hotelSettings.inHouseServices.all(config.defaultTerminalIhsId)" v-if="item.type === 'PrePayment'" :value="item.id" v-html="item.name[$shortLocale]"></option>
          </hm-input-select>
          <hm-input-select id="defaultTerminalId"
                           v-model="config.defaultTerminalId"
                           :label="$t('admin.interfaces.pagePaymentRequest.defaultTerminalId')"
                           name="defaultTerminalId"
                           cols="12">
            <option v-if="templates.length <= 1" :value="null"></option>
            <option v-for="terminal in hotelSettings.interfaces.stripe.terminals" :value="terminal.first">{{ terminal.second }} ({{ terminal.first }})</option>
          </hm-input-select>
          <hm-input-select id="terminalConfirmationEmailTemplateId"
                           v-model="config.terminalConfirmationEmailTemplateId"
                           :label="$t('admin.interfaces.pagePaymentRequest.terminalConfirmationEmailTemplateId')"
                           name="terminalConfirmationEmailTemplateId"
                           no-select
                           cols="12">
            <option v-if="templates.length <= 1" :value="null"></option>
            <option v-for="template in templates" :value="template.id">{{ template.name }}</option>
          </hm-input-select>
        </hm-card-inner>
      </card>

    </template>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import Card from '../../../lib/layout/Card';
import HmInputCheckbox from '../../../lib/inputs/HmInputCheckbox';
import HmInputMoney from '../../../lib/inputs/HmInputMoney';
import HmCardInner from '../../../lib/layout/HmCardInner';
import HmTextarea from '../../../lib/inputs/HmTextarea';
import HmTable from '../../../lib/table/HmTable';
import { cloneDeep, groupBy, isEmpty, isNil, keyBy, map, sortBy } from 'lodash';
import TabableCard from '../../../lib/layout/TabableCard';
import TabableCardContent from '../../../lib/layout/TabableCardContent';
import { TimelineMax, TweenMax } from 'gsap';
import { isProduction } from '@/lib/util/isProduction';
import TimerMixin from '../../../../mixins/TimerMixin';
import HmInputMultilang from '../../../lib/inputs/HmInputMultilang';

export default {
  name: 'PageTermianlPaymentRequestSettings',
  components: { HmInputMultilang, TabableCardContent, TabableCard, HmTable, HmTextarea, HmCardInner, HmInputMoney, HmInputCheckbox, Card },
  mixins: [HotelmeisterMixin, SaveWatchMixin, TimerMixin],

  autosave: [
    {
      name: 'config',
      variable: 'config',
      event: 'hotelSettings.update',
      fn: function (cbSaveComplete) {
        const storeConfig = cloneDeep(this.config);

        this.axios.put(this.serviceUrls.interfaces.paymentRequest.terminal.get(this, this.interfaceId), storeConfig)
          .then((response) => {
            this.showMessages(response);
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
          })
          .finally(() => {
            cbSaveComplete();
          });
      },
    },
  ],

  data() {
    return {
      subConfig: 'terminalConfiguration',
      config: null,
      stripeConfig: {
        enabled: false,
      },
      fanzConfig: {
        enabled: false,
      },
      interfaceId: this.$route.params.interfaceId,
      templates: [],
    };
  },

  computed: {
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
    disabledPaymentServiceProviders: function () {
      const ret = [];

      if (!this.hasLicense('InterfaceStripe') || this.stripeConfig.enabled !== true) ret.push('Stripe');

      return ret;
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.interfaces.paymentRequest.terminal.get(this, null))
        .then((response) => {
          const tmp = {
            ...response.data.data,
          };

          this.setTimeout(() => {
            this.config = tmp;
          }, 500);
        });
      this.axios.get(this.serviceUrls.interfaces.stripe.get(this, null))
        .then((response) => {
          this.stripeConfig = response.data.data;
        });
      this.updateTemplates();
    },
    updateTemplates() {
      this.axios.get(this.serviceUrls.templateHelper.filter(this, 'Email'))
        .then((response) => {
          this.templates = response.data.data.filter(it => it.type === 'GenericEmail' || it.type === 'PaymentConfirmationEmail');
        });
    },
    isProduction() {
      return isProduction;
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageTerminalPaymentRequestSettings.vue